import { Api } from '@axiom/ui';
import type { BannerMessage } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import { BannerMessageEntity } from '../entities/banner-message-entity';

class BannerMessagesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readBannerMessages({ appName }: { appName: BannerMessage['appName'] }) {
    return super.read<{ data: BannerMessage | null }>({
      endpoint: `/bannerMessages/${appName}`,
      method: 'GET',
      schema: { data: BannerMessageEntity },
    });
  }

  async refreshBannerMessages({
    appName,
  }: {
    appName: BannerMessage['appName'];
  }) {
    return super.invalidate(`/bannerMessages/${appName}`);
  }
}

export const LegacyBannerMessagesApi = new BannerMessagesApiClass();
